import { useEffect, useState } from 'react'

export const useNotificationPermission = () => {
  const [hasGrantedPermission, setHasGrantedPermission] = useState(false)

  useEffect(() => {
    if (!('Notification' in window) && hasGrantedPermission) {
      return
    }

    try {
      switch (Notification.permission) {
        case 'default':
        case 'denied':
          Notification.requestPermission().then(permission =>
            setHasGrantedPermission(permission === 'granted')
          )
          break
        default:
          break
      }
    } catch (exception) {
      console.debug('[INFO]: Unsupported browser Notification API')
    }
  }, [hasGrantedPermission])

  return hasGrantedPermission
}
